import { render } from "./MainNotice.vue?vue&type=template&id=08f2b10d&scoped=true"
import script from "./MainNotice.vue?vue&type=script&lang=js"
export * from "./MainNotice.vue?vue&type=script&lang=js"

import "./MainNotice.vue?vue&type=style&index=0&id=08f2b10d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f2b10d"]])

export default __exports__